<template>
  <custom-dialog width="600px" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="dialog-body">
      <!-- 用户信息 -->
      <el-form :model="form" :rules="rules" ref="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.suo_shu_ying_yong')" prop="appId">
              <el-select disabled v-model="form.appId" @change="getMenuTree()">
                <el-option v-for="item in appList" :key="item.appId" :label="item.appName" :value="item.appId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.shang_ji_cai_dan')">
              <custom-select
                v-model="form.parentId"
                :props="{
                  label: 'menuName',
                  value: 'menuId',
                  checkStrictly: true,
                }"
                type="tree"
                url="MenuTree"
                :show-all-levels="false"
                :params="{ appId: form.appId, menuId: menuId }"
              ></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_ming_cheng')" prop="menuName">
              <el-input v-model="form.menuName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_dai_ma')" prop="menuCode">
              <el-input v-model="form.menuCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_lei_xing')" prop="menuType">
              <custom-select v-model="form.menuType" code="bas_menuType" :clearable="false"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_lian_jie')" prop="loadRes">
              <el-input v-model="form.loadRes"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.duo_yu_yan_dai_ma')" prop="langMenuName">
              <el-input v-model="form.langMenuName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_tu_biao')" prop="menuIcon">
              <el-input v-model="form.menuIcon"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.da_kai_fang_shi')">
              <custom-select v-model="form.showWay" code="bas_menu_showWay" :clearable="false"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('base_menu_item_dialog.xian_shi_shun_xu')" prop="showOrder">
              <el-input type="number" min="0" v-model.number="form.showOrder"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('base_menu_item_dialog.cai_dan_miao_shu')" prop="menuDesc">
              <el-input type="textarea" v-model="form.menuDesc"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="saveGroup">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
// import Treeselect from '@riophae/vue-treeselect';
import apis from '@/utils/apis';
// import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  // components: { Treeselect },
  mixins: [dialogMixins],
  data() {
    return {
      appList: [],
      menuTree: [],
      menuId: '',
      form: {
        appId: '',
        menuId: '',
        langMenuName: '',
        loadRes: '',
        menuCode: '',
        menuDesc: '',
        menuIcon: '',
        menuName: '',
        menuType: '',
        parentId: null,
        showOrder: 0,
        showWay: '',
      },
    };
  },
  computed: {
    rules() {
      return {
        appId: {
          required: true,
          message: this.$t('Common.com_required'),
        },
        menuName: [
          {
            required: true,
            message: this.$t('base_menu_item_dialog.cdmcbt'),
          },
          { max: 20, message: this.$t('Common.com_rules_length_max', [20]), },
        ],
        menuCode: [
          {
            required: true,
            message: this.$t('base_menu_item_dialog.cddmbt'),
          },
          { max: 30, message: this.$t('Common.com_rules_length_max', [30]), },
        ],
        loadRes: [
          {
            required: true,
            message: this.$t('base_menu_item_dialog.cdljbt'),
          },
          { max: 100, message: this.$t('Common.com_rules_length_max', [100]), },
        ],
        langMenuName: [
          {
            required: true,
            message: this.$t('base_menu_item_dialog.dyydmbt'),
          },
          { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        ],
        showOrder: {
          type: 'number',
          min: 0,
          message: this.$t('Common.com_rules_number_min', [0]),
        },
        menuIcon: { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
        menuDesc: { max: 50, message: this.$t('Common.com_rules_length_max', [50]), },
      };
    },
  },
  mounted() {
    this.initDialog();
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.getDictionary('bas_menuType,bas_menu_showWay', () => {
        if (this.model.type === 'add') {
          this.form.menuType = this.propertyMap.bas_menuType[0] && this.propertyMap.bas_menuType[0]['value'];
          this.form.showWay = this.propertyMap.bas_menu_showWay[0] && this.propertyMap.bas_menu_showWay[0]['value'];
        }
      });
      this.getAppList(); // 获取应用列表
      if (this.model.type === 'add') {
        this.menuId = '';
        this.form.appId = this.model.data.appId; // 所属应用
      }
      if (this.model.type === 'edit') {
        const row = this.model.data.item;
        row.parentId = row.parentId === '0' ? null : row.parentId;
        this.menuId = row.menuId;
        this.$setFormatData(this.form, row);
      }
      this.getMenuTree();
    },
    // 下拉树配置
    normalizer(node) {
      return {
        id: node.menuId,
        label: node.menuName,
      };
    },
    // 应用平台
    getAppList: function () {
      this.$getJSON(apis.AppMenu).then((res) => {
        this.appList = res.data;
      });
    },
    // 获取菜单树
    getMenuTree: function () {
      this.$getJSON(apis.MenuTree, {
        appId: this.form.appId,
        menuId: this.menuId,
      }).then((res) => {
        this.menuTree = res.data;
      });
    },
    // 确认保存菜单
    saveGroup: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        if (this.model.type === 'add') {
          this.saveAddMenu();
        }
        if (this.model.type === 'edit') {
          this.saveEditMenu();
        }
      });
    },
    getTreeProp(data, propName, defaultVal = '') {
      if (Array.isArray(data[propName])) {
        const len = Math.max(data[propName].length - 1, 0);
        return data[propName][len] || defaultVal;
      }
      return data[propName] || defaultVal;
    },
    getReqData() {
      return {
        ...this.form,
        parentId: this.getTreeProp(this.form, 'parentId'),
      };
    },
    // 保存新增菜单
    saveAddMenu: function () {
      this.$postJSON(apis.MenuAdd, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_add_success'),
          type: 'success',
        });
        this.$emit('success');
        this.visible = false;
      });
    },
    // 保存编辑分组
    saveEditMenu: function () {
      this.form.menuId = this.menuId;
      this.$postJSON(apis.MenuUpdate, this.getReqData(), true).then(() => {
        this.$message({
          message: this.$t('Common.com_edit_success'),
          type: 'success',
        });
        this.visible = false;
        this.$emit('success', this.getReqData());
      });
    },
  },
};
</script>

<style lang="scss"></style>
